module.exports = __webpack_public_path__ + "img/thumbnail_StandardDonkey_j_normal.a82a89b7.png";